import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

import {
  AppClient,
  HelpSectionInterface,
  KeystringValueInterface,
  MarketGroupInterface,
  MarketInterface,
  NewsInterface,
  ToolInterface,
  UserinfoInterface
} from '../../models/sharedinterface';

@Injectable({
  providedIn: 'root'
})
export class ShareddataService {

  // mandant news
  private newsSource = new BehaviorSubject([]);
  currentNews = this.newsSource.asObservable();

  private mandantLabel$ = new BehaviorSubject('');
  mandantLabel = this.mandantLabel$.asObservable();

  private iframeURL$ = new BehaviorSubject('');
  currentiframeURL = this.iframeURL$.asObservable();

  private iFrameHeight$ = new BehaviorSubject('');
  currentIFrameHeight = this.iFrameHeight$.asObservable();

  private selectedUser$ = new BehaviorSubject<UserinfoInterface>({});
  selectedUser = this.selectedUser$.asObservable();

  private markets$ = new BehaviorSubject<MarketInterface[]>([]);
  markets = this.markets$.asObservable();

  private marketGroups$ = new BehaviorSubject<MarketGroupInterface[]>([]);
  marketGroups = this.marketGroups$.asObservable();

  private companies$ = new BehaviorSubject<any[]>([]);
  companies = this.companies$.asObservable();

  private languages$ = new BehaviorSubject<any[]>([]);
  languages = this.languages$.asObservable();

  private titles$ = new BehaviorSubject<any[]>([]);
  titles = this.titles$.asObservable();

  private users$ = new BehaviorSubject<any[]>([]);
  users = this.users$.asObservable();

  private appclients$ = new BehaviorSubject<any[]>([]);
  appclients = this.appclients$.asObservable();

  private newsposition$ = new BehaviorSubject<string>('center');
  newsposition = this.newsposition$.asObservable();

  private tools$ = new BehaviorSubject<ToolInterface[]>([]);
  tools = this.tools$.asObservable();

  toolOrderListData$ = new BehaviorSubject([]);

  isloggedin$: BehaviorSubject<boolean>;
  currentlanguage$: BehaviorSubject<KeystringValueInterface>;
  currenttool$: BehaviorSubject<ToolInterface>;
  currentNews$: BehaviorSubject<NewsInterface[]>;
  backgroundstyle$: BehaviorSubject<string>;
  sharedhelpdata$: BehaviorSubject<HelpSectionInterface[]>;
  userroles$: BehaviorSubject<string[]>;
  ispreloading$: BehaviorSubject<boolean>;
  mandanttitle$: BehaviorSubject<string>;
  editprofilviewinterface$: BehaviorSubject<any>;
  usertools$: BehaviorSubject<ToolInterface[]>;

  constructor() {
    this.isloggedin$ = new BehaviorSubject<boolean>(false);
    this.currentlanguage$ = new BehaviorSubject<KeystringValueInterface>({key: 'en', value: 'English'});
    this.currenttool$ = new BehaviorSubject<ToolInterface>({
      toolid: 0,
      clientid: 0,
      toolkeyword: '',
      toolclassname: '',
      toolpath: ''
    });
    this.currentNews$ = new BehaviorSubject<NewsInterface[]>([]);
    this.currentIFrameHeight = new BehaviorSubject<string>('');
    this.backgroundstyle$ = new BehaviorSubject<string>('#ffffff');
    this.sharedhelpdata$ = new BehaviorSubject<HelpSectionInterface[]>([]);
    this.userroles$ = new BehaviorSubject<string[]>([]);
    this.ispreloading$ = new BehaviorSubject<boolean>(false);
    this.mandanttitle$ = new BehaviorSubject<string>('');
    this.editprofilviewinterface$ = new BehaviorSubject<any>([]);
    this.usertools$ = new BehaviorSubject<ToolInterface[]>([]);
    this.toolOrderListData$ = new BehaviorSubject([]);
  }

  isLoggedin() {
    return this.isloggedin$.getValue();
  }

  changeiframeURL(url: string) {
    this.iframeURL$.next(url);
  }

  getCurrentlanguage() {
    return this.currentlanguage$.getValue();
  } // getCurrentlanguage

  setCurrentlanguage(language: KeystringValueInterface) {
    this.currentlanguage$.next(language);
  } // setCurrentlanguage

  getCurrentTool(): ToolInterface {
    return this.currenttool$.getValue();
  } // getCurrentTool

  setCurrentTool(tool: ToolInterface) {
    this.currenttool$.next(tool);
  } // setCurrentTool

  // mandant news
  changeNews(news: any) {
    this.newsSource.next(news);
  }

  getCurrentNews(): NewsInterface[] {
    return this.currentNews$.getValue();
  } // getCurrentNews

  setCurrentNews(news: NewsInterface[]) {
    this.currentNews$.next(news);
  } // setCurrentNews

  getSelectedUser(): UserinfoInterface {
    return this.selectedUser$.getValue();
  } // getSelectedUser

  setSelectedUser(selectedUser: UserinfoInterface) {
    this.selectedUser$.next(selectedUser);
  } // setSelectedUser

  getMarkets(): MarketInterface[] {
    return this.markets$.getValue();
  }

  setMarkets(markets: MarketInterface[]) {
    this.markets$.next(markets);
  }

  getMarketGroups(): MarketGroupInterface[] {
    return this.marketGroups$.getValue();
  }

  setMarketGroups(marketGroups: MarketGroupInterface[]) {
    this.marketGroups$.next(marketGroups);
  }

  getCompanies(): any[] {
    return this.companies$.getValue();
  }

  setCompanies(companies: any[]) {
    this.companies$.next(companies);
  }

  getLanguages(): any[] {
    return this.languages$.getValue();
  }

  setLanguages(languages: any[]) {
    this.languages$.next(languages);
  }

  getTitles(): any[] {
    return this.titles$.getValue();
  }

  setTitles(titles: any[]) {
    this.titles$.next(titles);
  }

  /**
   * Gets the user list
   * @param active active flag to filter users (set to null to avoid filter)
   * @param deleted deleted flag to filter users (set to null to avoid filter)
   */
  getUsers(active: boolean | null = null, deleted: boolean | null = false): any[] {
    let filteredUsers: any[] = this.users$.getValue();
    if (active === true || active === false) {
      console.log('filtering by active ' + active);
      filteredUsers = filteredUsers.filter(u => u.active === Number(active));
    }
    if (deleted === true || deleted === false) {
      console.log('filtering by deleted ' + deleted);
      filteredUsers = filteredUsers.filter(u => u.deleted === Number(deleted));
    }
    return filteredUsers;
  }

  setUsers(users: any[]) {
    this.users$.next(users);
  }

  getMandantLabel(): string {
    return this.mandantLabel$.getValue();
  } // getMandantLabel

  setMandantLabel(mandantLabel: string) {
    this.mandantLabel$.next(mandantLabel);
  } // setMandantLabel

  getCurrentIFrameHeight(): string {
    return this.iFrameHeight$.getValue();
  } // getCurrentNews

  setCurrentIFrameHeight(height: string) {
    this.iFrameHeight$.next(height);
  } // setCurrentNews

  getBackgroundstyle(): string {
    return this.backgroundstyle$.getValue();
  } // getBackgroundstyle

  setBackgroundstyle(backgroundstyle: string) {
    this.backgroundstyle$.next(backgroundstyle);
  } // setBackgroundstyle

  getSharedhelpdata(): HelpSectionInterface[] {
    return this.sharedhelpdata$.getValue();
  } // getSharedhelpdata

  setSharedhelpdata(sharedhelpdata: HelpSectionInterface[]) {
    this.sharedhelpdata$.next(sharedhelpdata);
  } // setSharedhelpdata

  getUserroles(): string[] {
    return this.userroles$.getValue();
  } // getUserroles

  setUserroles(useroles: string[]) {
    this.userroles$.next(useroles);
  } // setUserroles

  getIspreloading(): boolean {
    return this.ispreloading$.getValue();
  } // getIspreloading

  setIspreloading(ispreloading: boolean) {
    this.ispreloading$.next(ispreloading);
  } // setIspreloading

  getMandanttitle(): string {
    return this.mandanttitle$.getValue();
  } // getMandanttitle

  setMandanttitle(mandanttitle: string) {
    this.mandanttitle$.next(mandanttitle);
  } // setMandanttitle


  getEditprofilviewinterface(): any {
    return this.editprofilviewinterface$.getValue();
  } // getMandanttitle

  setEditprofilviewinterface(editprofilviewinterface: any) {
    console.log(editprofilviewinterface);
    this.editprofilviewinterface$.next(editprofilviewinterface);
  } // setMandanttitle

  getTools(): ToolInterface[] {
    return this.tools$.getValue();
  } // getUserTools

  setTools(tools: ToolInterface[]) {
    this.tools$.next(tools);
  } // setUserTools

  getUserTools(): ToolInterface[] {
    return this.usertools$.getValue();
  } // getUserTools

  setUserTools(userTools: ToolInterface[]) {
    this.usertools$.next(userTools);
  } // setUserTools

  setToolOrderListData(toolOrderListData: any) {
    this.toolOrderListData$.next(toolOrderListData);
  }

  getAppClients(): AppClient[] {
    return this.appclients$.getValue();
  } // getUserTools

  setAppClients(appclients: AppClient[]) {
    this.appclients$.next(appclients);
  } // setUserTools

  getNewsPosition(): string {
    return this.newsposition$.getValue();
  } // getUserTools

  setNewsPosition(newsposition) {
    this.newsposition$.next(newsposition);
  } // setUserTools
}
